module.exports = __webpack_public_path__ + "static/media/ww_hidr1.d66d6372.gif";